// src/hooks/nationalities/useGetNationalities.js
import { useQuery } from "@tanstack/react-query";
import { getAllNationalities } from "../../api/apiNationalities";

const QUERY_KEY = ["nationalities"];

const useGetNationalities = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllNationalities(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    error: isError ? error : null,
    nationalities: data?.data || data?.nationalities || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetNationalities;